import React from "react";
import Css from "./FrameReact.module.css";
import { Link } from "react-router-dom";
import FrameWorkImage from "../PackageImage/FrameWorkImage";
const FrameReact = () => {
  const products = [
    {
      id: 1,
      title: "Website ShopClothes",
      FrameWork: "React",
      paragraph: "4th Project talking about shopping Household & This Website",
      span: "Responsive",
      Preview: "https://shopclothes1.netlify.app/",
      GitHub: "https://github.com/Mohamed-Adel0/ShopClothes",
      image: FrameWorkImage.ShopClothes,
    },
    {
      id: 2,
      title: "Website ShopWise",
      FrameWork: "React",
      paragraph: "3rd Project talking about shopping Household & This Website",
      span: "Responsive 80%",
      Preview: "https://shopwise97.netlify.app/",
      GitHub: "https://github.com/Mohamed-Adel0/Shopwise",
      image: FrameWorkImage.ShopWise,
    },
    {
      id: 3,
      title: "Website ShowRoom",
      FrameWork: "React",
      paragraph: "5th Project talking about Show Room & This Website",
      span: "Responsive 90%",
      Preview: "https://showroom97.netlify.app/",
      GitHub: "https://github.com/Mohamed-Adel0/Show-Room",
      image: FrameWorkImage.ShowRoom,
    },
    {
      id: 4,
      title: "Website Anime",
      FrameWork: "React",
      paragraph: "2nd Project using React for training & This Website",
      span: "Responsive 80%",
      Preview: "https://anime97.netlify.app/",
      GitHub: "https://github.com/Mohamed-Adel0/Anime",
      image: FrameWorkImage.Anime,
    },
    {
      id: 5,
      title: "Website Coffe",
      FrameWork: "React",
      paragraph: "1st Project using React for training & This Website",
      span: "Not Responsive",
      Preview: "https://coffe97.netlify.app/",
      GitHub: "https://github.com/Mohamed-Adel0/Caffe",
      image: FrameWorkImage.Coffe,
    },
  ];
  return (
    <div>
      <div className={Css.container}>
        {products?.map((r) => (
          <div className={Css.cards} key={r.id}>
            <div className={Css.card}>
              <div className={Css.img}>
                <Link to={r.Preview} target="_blank">
                  <img src={r.image} alt="" />
                </Link>
              </div>
              <div className={Css.text}>
                <h2>
                  {r.title} <span>{r.FrameWork}</span>
                </h2>
                <p>
                  {r.paragraph} <span>{r.span}</span>
                </p>
                <div className={Css.src}>
                  <Link target="_blank" to={r.Preview}>
                    Preview
                  </Link>
                  <Link target="_blank" to={r.GitHub}>
                    GitHub
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FrameReact;
